module.exports = __webpack_public_path__ + "img/no.v4.2.3.1783565180906.png";